import FormResetPassword from '../../../components/pages/resetPassword/FormResetPassword';
import DefaultPage from '../defatulPage';

const RecoveryPassword: React.FC = () => {
  return (
    <DefaultPage justifyContent="start" mt="30%">
      <FormResetPassword />
    </DefaultPage>
  );
};

export default RecoveryPassword;
